/**
 *
 * @param {Object} obj
 * @param {string[]} propList
 * @param {function(*): number} fn
 * @return {Object}
 */
export function transformProps(obj, propList, fn) {
  return {
    ...obj,
    ...propList.reduce((acc, prop) => {
      if (obj[prop] !== undefined) {
        acc[prop] = fn(obj[prop]);
      }

      return acc;
    }, {}),
  };
}

/**
 * @param {*} obj
 * @param {string[]} propList
 * @param {boolean} createEmptyProps
 * @param defaultValue
 */
export function filterProps(
  obj,
  propList,
  createEmptyProps = false,
  defaultValue = undefined
) {
  return propList.reduce((acc, prop) => {
    if (obj[prop] !== undefined) {
      acc[prop] = obj[prop];
    } else if (createEmptyProps) {
      acc[prop] = defaultValue;
    }

    return acc;
  }, {});
}
